import * as PIXI from 'pixi.js'
import 'gsap/PixiPlugin'
import 'pixi-sound'
import Game from './game.js'
import Background from './background.js'
import Progress from './progress.js'

// from:https://github.com/jserz/js_piece/blob/master/DOM/ChildNode/remove()/remove().md
(function (arr) {
  arr.forEach(function (item) {
    if (item.hasOwnProperty('remove')) {
      return;
    }
    Object.defineProperty(item, 'remove', {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function remove() {
        if (this.parentNode !== null)
          this.parentNode.removeChild(this);
      }
    });
  });
})([Element.prototype, CharacterData.prototype, DocumentType.prototype]);

if (!String.prototype.repeat) {
  String.prototype.repeat = function(count) {
    'use strict';
    if (this == null) {
      throw new TypeError('can\'t convert ' + this + ' to object');
    }
    var str = '' + this;
    count = +count;
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }
    // Ensuring count is a 31-bit integer allows us to heavily optimize the
    // main part. But anyway, most current (August 2014) browsers can't handle
    // strings 1 << 28 chars or longer, so:
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var rpt = '';
    for (var i = 0; i < count; i++) {
      rpt += str;
    }
    return rpt;
  }
}

String.prototype.padStart = function padStart (targetLength, padString) {
  targetLength = targetLength >> 0 //truncate if number or convert non-number to 0;
  padString = String((typeof padString !== 'undefined' ? padString : ' '))
  if (this.length > targetLength) {
    return String(this)
  } else {
    targetLength = targetLength - this.length
    if (targetLength > padString.length) {
      padString += padString.repeat(targetLength / padString.length) //append to original to ensure we are longer than needed
    }
    return padString.slice(0, targetLength) + String(this)
  }
}

//
// Let's Play a Game
//

const game = new Game()

//
// Background
//

game.background = new Background(game)

//
// Loading
//

game.progress = new Progress(game)

PIXI.loader
  .add('bg', 'images/background/bg.png')
  .add('title', 'images/loading/title.png')
  .add('man', 'images/loading/man.png')
  .add('manInSleep', 'images/loading/man-in-sleep.png')
  .load(game.progress.init.bind(game.progress))

game.progress.onLoaded = game => {
  game.start()
}

//
// We're hiring
//

console.log(
  `



                   %c'----'
                .+o/-..-/o+-
              .o+.        '/s-
             'y.            'y-
            ./y. '.-::::-.' 'y/:
           .y--//:.'    '.://:.y-
          '++/-'.o/'    '/s-'-//+.
          :+.     -+o/:oo-     .+:
         /:          '.          :+
        .+                        +.
        'o'                      'o'
         .+-                    -+.
           :+.                .+:
            ':+.            .+:'
               :+-'      '-+:'
                 .//-..-//-
                    ....



%c+--------------------------------------------+
|            We are Backer-Founder           |
|    Curious? We're hiring Web Engineers.    |
| ------------------------------------------ |
|                                            |
|          chh@backer-founder.com            |
|                                            |
+--------------------------------------------+`,
  "color: #8cafe0",
  "color: #fff; background-color: #6292d6; line-height: 1.414;"
);
